import styled from 'styled-components';
import { baseVariables, toRem } from '@marriott/mi-ui-library';

export const StyledCompareCard = styled.div`
  border-radius: ${toRem(12)};
  position: relative;

  .card-container {
    height: 100%;
    border-radius: ${toRem(8)};
    border: ${baseVariables.border.borderWidth02} ${baseVariables.border.borderStyleDefault}
      ${baseVariables.color.base10};
    padding: ${toRem(16)} ${toRem(16)};
    @media ${baseVariables.mediaQuery.md} {
      max-width: ${toRem(192)};
      max-height: ${toRem(152)};
      padding: ${toRem(24)} ${toRem(16)};
    }

    .card-image {
      width: ${toRem(80)};
      height: ${toRem(50)};
      @media ${baseVariables.mediaQuery.md} {
        width: ${toRem(91)};
        height: ${toRem(57)};
      }
    }
    .card-tag,
    .card-sm-tag {
      width: fit-content;
      padding: ${toRem(4)} ${toRem(8)};
      border-radius: ${toRem(4)};
      background-color: ${baseVariables.color.neutral30};
      text-transform: uppercase;
      p {
        line-height: ${toRem(14)};
      }
    }
    .card-tag {
      position: absolute;
      top: 0;
      left: 0;
      border-radius: ${toRem(8)} ${toRem(0)} ${toRem(4)} ${toRem(0)};
      border-top: ${baseVariables.border.borderWidth02} ${baseVariables.border.borderStyleDefault}
        ${baseVariables.color.base10};
      border-left: ${baseVariables.border.borderWidth02} ${baseVariables.border.borderStyleDefault}
        ${baseVariables.color.base10};
    }
    .business-badge {
      background-color: ${baseVariables.color.merch20};
      p {
        color: ${baseVariables.color.base20};
      }
    }
    .card-header {
      line-height: ${toRem(12)};
    }
  }
  .remove-card {
    width: ${toRem(32)};
    height: ${toRem(32)};
    padding: ${toRem(4)};
    background-color: ${baseVariables.color.neutral20};
    color: ${baseVariables.color.base10};
    border-radius: ${toRem(4)};
    font-size: ${toRem(24)};
    position: absolute;
    top: ${toRem(8)};
    right: ${toRem(8)};
    &:focus-visible {
      outline: -webkit-focus-ring-color auto ${toRem(1)};
    }
  }
  .card-shell {
    height: 100%;
    border-radius: ${toRem(8)};
    border: ${baseVariables.border.borderWidth02} dashed ${baseVariables.color.neutral30};
    padding: ${toRem(24)} ${toRem(16)};
    @media ${baseVariables.mediaQuery.md} {
      width: ${toRem(192)};
      max-height: ${toRem(152)};
    }

    .shell-subtitle {
      color: ${baseVariables.color.neutral40};
    }
  }
`;
